export const assets = {
  socialImage: '/social-image.png',
  logo: '/logo.svg',
  favicon: '/favicon.ico',
  extension: {
    panel: '/screenshots/vscode-extension-placeholder.svg',
    feature: '/screenshots/vscode-extension-feature-placeholder.svg'
  },
  hero: {
    dragDrop: '/hero-drag-drop.png',
    vscodeFeature: '/hero-vscode-feature.png'
  },
  // Add more assets as needed
};
